var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chatbot-entry"},[_c('div',{staticClass:"chatbot-entry__label"},[_vm._v("Entry Point")]),_vm._v(" "+_vm._s(_vm.localSettings.name || 'EntryPoint')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }